<template>
  <div
    :class="$options.name"
    class="tw:mt-auto tw:flex tw:flex-col tw:items-center tw:justify-center tw:px-2 py-3 tw:w-full tw:h-fit tw:min-h-fit"
  >
    <LiveStormEvents :show="isPinned || isHover" class="tw:mb-3 tw:self-stretch" />
    <RestoreAccount
      v-if="removeTrackerData && isSuperagent"
      :active-until="removeTrackerData.scheduledRemovalDate"
      :is-loading="isLoading"
      :type="isHover || isPinned ? 'normal' : 'small'"
      class="tw:w-full"
      is-vertical
      @chat="handleIntercom"
      @restore-account="handleRestore"
    />
    <FreemiumBanner v-else :show="isPinned || isHover" class="tw:mb-3 tw:self-stretch" />

    <Transition
      enter-active-class="tw:transition-[transform] tw:duration-150 tw:ease-in-out"
      :enter-from-class="[isPinned || isHover ? 'tw:translate-x-0' : 'tw:translate-x-0'].join(' ')"
      leave-active-class="tw:transition-[transform] tw:duration-150 tw:ease-it-out"
      :leave-to-class="[isPinned || isHover ? 'tw:translate-x-2' : 'tw:-translate-x-2'].join(' ')"
      mode="out-in"
    >
      <div v-if="isPinned || isHover" class="tw:w-full tw:flex tw:flex-col tw:gap-3">
        <MainMenuSettings @keep-hovered="$emit('keepHovered', $event)" />
        <MainMenuDemoLanguageSwitcher v-if="isDemo" />
        <MainMenuDeveloperMode v-if="user.canSetIsDev" />
      </div>

      <div v-else class="tw:w-full tw:flex tw:flex-col tw:gap-2 tw:items-start">
        <div class="tw:flex tw:justify-center tw:items-center tw:py-2">
          <img
            :alt="trans._menu.header.workspace.avatar"
            :src="userImage"
            class="tw:border tw:border-default-200 tw:rounded-full tw:w-8 tw:h-8 tw:min-w-8 tw:object-contain tw:bg-default-100"
          />
        </div>
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { defineEmits, defineProps, computed } from "vue";
import MainMenuSettings from "./MainMenuSettings.vue";
import MainMenuDeveloperMode from "./MainMenuDeveloperMode.vue";
import MainMenuDemoLanguageSwitcher from "vue-app/components/MainMenu/MainMenuDemoLanguageSwitcher.vue";
import FreemiumBanner from "vue-app/components/Freemium/FreemiumBanner.vue";
import LiveStormEvents from "vue-app/components/LiveStormEvents/LiveStormEvents.vue";
import RestoreAccount from "vue-app/components/RestoreAccount/RestoreAccount.vue";
import { useStore } from "vuex";
import useRestoreTracker from "vue-app/composables/useRestoreTracker";

const store = useStore();
interface Emits {
  (event: "keepHovered", value: boolean): void;
}

interface Props {
  isPinned: boolean;
  isHover: boolean;
}

defineProps<Props>();
defineEmits<Emits>();

const isDemo = window.EDRONE_CONTEXT.isDemo;
const user = window.EDRONE_CONTEXT.user;
const brandingLogo = window.EDRONE_CONTEXT.tracker?.trackerBranding?.logoUrl;
const userAvatar = user.avatar
  ? user.avatar.includes("https")
    ? user.avatar
    : "https://dgk28ckagqims.cloudfront.net/avatars/" + user.avatar
  : "https://d3vhsxl1pwzf0p.cloudfront.net/avatar/user.svg";
const userImage = user.isSupport
  ? brandingLogo || "https://d3vhsxl1pwzf0p.cloudfront.net/avatar/store.svg"
  : userAvatar;

const isSuperagent = computed(() => store.getters["global/isSuperagent"]);
const { getTrackerLeaveData, removeTrackerData, handleRestore, handleIntercom, isLoading } = useRestoreTracker();
getTrackerLeaveData();
</script>
